import { useSchema } from 'features/traffic/campaigns/useSchema';
import { useEffect } from 'react';
import { useCampaignConfig } from '../../hooks/useCampaignConfig';
import type { FlavorPath } from '../../mcc.types';
import { useFlavorFromOtherName } from '../../useFlavor';

type FlavorContentEditorProps = {
  name: FlavorPath;
};

const UnknownCampaignSchemaDisplay = ({ name }: { name: string }) => {
  const schema = useSchema();
  const flavor = useFlavorFromOtherName(name);
  useEffect(() => {
    console.error('unknown flavor type', {
      flavor,
      schema,
    });
    return () => {};
  }, [
    flavor,
    schema,
  ]);
  return (
    <div>
      <div>unknown flavor type</div>
      <pre>{`schema: ${schema}`}</pre>
      <pre>{`${name}`}</pre>
      <p>If you are adding a new campaign type, please add it to the config system.</p>
    </div>
  );
};

export const FlavorContentEditor = ({ name }: FlavorContentEditorProps) => {
  const config = useCampaignConfig();
  // Should NEVER, but could be useful if someone made a typo.
  if (!config?.contentSection?.FlavorContentEditor) return <UnknownCampaignSchemaDisplay name={name} />;

  // Get content editor for the campaign type and render it.
  const FlavorContentEditor = config.contentSection.FlavorContentEditor;
  return <FlavorContentEditor name={name} />;
};
